var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.361,
    height: 26.361,
    viewBox: "0 0 26.361 26.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_945",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 945",
    transform: "translate(-701 -2797.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-facebook-5",
    d: "M1733.513,1755.973h-2.2v2.2h2.2v6.59h3.3v-6.59h2l.2-2.2h-2.2v-.915c0-.525.11-.733.613-.733H1739v-2.746h-2.636c-1.977,0-2.856.87-2.856,2.535Z",
    transform: "translate(-1021.528 1052.806)",
    fill: "#d19f46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_3",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 3",
    transform: "translate(701 2797.794)",
    fill: "none",
    stroke: "#d19f46",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.181,
    cy: 13.181,
    r: 13.181,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.181,
    cy: 13.181,
    r: 12.681,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFb);
export default __webpack_public_path__ + "static/media/icon_fb.51acbf473687e5e24b2a00497d828606.svg";
export { ForwardRef as ReactComponent };